
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelNorth as ObiBuoyBarrelNorthElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-north.js';
 
 
 

 
 export const ObiBuoyBarrelNorth = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-north',
   elementClass: ObiBuoyBarrelNorthElement,
   events: {
     
   }
  });
 
 